export default __webpack_public_path__ + "static/media/interactive3.ca429680.svg";